import {
  createOrganization,
  createOrganizationFromLabel
} from "Reducers/organization/organization";
import { createProject } from "Reducers/projectCreation/thunks/createProject.thunk";
import { createProjectFromGithub } from "Reducers/projectCreation/thunks/createProjectFromGithub.thunk";

// The conversion vocabulary, shared by every ad platform. Platforms translate
// these into their own events (see `platforms/`); they do not extend the list.
export type ConversionName =
  "organizationCreated" | "projectCreated" | "paymentMethodAdded";

// Maps Redux action types to the conversion they trigger. `paymentMethodAdded`
// has no entry: adding a payment source is a direct client call with no
// dedicated action, so it is fired imperatively via `trackConversion`.
export const CONVERSION_ACTIONS: Record<string, ConversionName> = {
  // The Create-Organization UI dispatches `createOrganizationFromLabel`; the
  // deprecated `createOrganization` still backs the auto-create and
  // error-recovery flows. The two are mutually exclusive, so no double count.
  [createOrganization.fulfilled.type]: "organizationCreated",
  [createOrganizationFromLabel.fulfilled.type]: "organizationCreated",
  [createProject.fulfilled.type]: "projectCreated",
  [createProjectFromGithub.fulfilled.type]: "projectCreated"
};
